import React from 'react';
import PropTypes from 'prop-types';

const { Card, PolycardContext } = require('@polycard/card');

const { transformData, generatePolycardContext } = require('./decorators');

const className = 'top-offers';

const TopOffers = (props) => {
  const { device, value } = props;
  const isMobile = device === 'mobile';

  const transformedData = transformData(value.top_offers);
  const polycardContext = generatePolycardContext(isMobile);

  return (
    <div className={className}>
      <div className={`${className}__content`}>
        <h2 data-testid="title" className={`${className}__title`}>
          {value.title}
        </h2>
        <div
          className={
            isMobile
              ? `${className}__cards-container--mobile`
              : `${className}__cards-container--desktop`
          }
        >
          <PolycardContext
            contextValue={{ ...polycardContext }}
            deviceType={isMobile ? 'mobile' : 'desktop'}
            thousandSeparator=","
            decimalSeparator="."
            countPreloadImages={3}
          >
            {transformedData.map((item, index) => (
              <Card
                key={item.metadata.id}
                cardNumber={index + 1}
                polycard={item}
              />
            ))}
          </PolycardContext>
        </div>
      </div>
    </div>
  );
};

TopOffers.propTypes = {
  device: PropTypes.string.isRequired,
  value: PropTypes.shape({
    title: PropTypes.string.isRequired,
    top_offers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        permalink: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        price: PropTypes.string.isRequired,
        currency_id: PropTypes.string.isRequired,
        vehicle_year: PropTypes.string.isRequired,
        kilometers: PropTypes.string.isRequired,
        city_name: PropTypes.string.isRequired,
        state_name: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
};

export default TopOffers;
